import React from 'react';

const Navbar = () => {
    return (
        <nav className="navbar" style={{height: '73px', backgroundColor: '#373464'}}>
            <div className="container-fluid">
                <div className="navbar-brand">
                    <div className="logo-cont">
                        <img src="/Images/Suyool-S-White-Logo.png" alt="Logo" className="navbar-logo"/>
                    </div>
                    <span className="navbar-title">Suyool Corporate Onboarding</span>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
